import React from 'react';
import { UncontrolledAlert } from "reactstrap";
import { Link } from 'react-router-dom';

const Popup = () => {
    return null;
}

export default Popup;